import { Skeleton } from "components/ui/skeleton";
import { cardClassName, cardHeaderClassName } from "./Card";

const CardHeaderSkeleton = () => (
  <div className={cardHeaderClassName}>
    <Skeleton className="h-7 w-40" />
  </div>
);

export const CaseHeaderSkeleton = () => (
  <div role="status" className="space-y-3">
    <span className="sr-only">Loading case</span>
    <Skeleton className="h-9 w-56" />
    <Skeleton className="h-6 w-72" />
    <Skeleton className="h-4 w-40" />
  </div>
);

export const RowsSkeleton = ({ rows }: { rows: number }) => (
  <ul aria-hidden="true" className="divide-y">
    {Array.from({ length: rows }, (_, index) => (
      <li key={index} className="flex items-center gap-4 px-6 py-4">
        <Skeleton className="size-9 shrink-0" />
        <div className="flex-1 space-y-2">
          <Skeleton className="h-4 w-1/2" />
          <Skeleton className="h-3 w-1/3" />
        </div>
        <Skeleton className="h-8 w-24 shrink-0" />
      </li>
    ))}
  </ul>
);

export const ListCardSkeleton = ({ rows }: { rows: number }) => (
  <div aria-hidden="true" className={cardClassName}>
    <CardHeaderSkeleton />
    <RowsSkeleton rows={rows} />
  </div>
);

export const SummaryCardSkeleton = ({ lines }: { lines: number }) => (
  <div aria-hidden="true" className={cardClassName}>
    <CardHeaderSkeleton />
    <div className="space-y-3 p-6">
      {Array.from({ length: lines }, (_, index) => (
        <Skeleton key={index} className="h-5 w-full" />
      ))}
    </div>
  </div>
);
